const route = [
  {
    path: '/additionals-charges',
    name: 'additionalsCharges',
    meta: { authRequired: true },
    component: () => import('./AdditionalsCharges')
  },
  {
    path: '/additionals-charges/documents',
    name: 'additionalsChargesDocs',
    meta: { authRequired: true },
    component: () => import('./Documents')
  }
];

module.exports = {
  route
};
